import React, { useEffect, useState } from "react";
import styles from "./PrivacyPolicy.module.css";
import { TextComponent } from "../../components";
import { useDispatch, useSelector } from "react-redux";
import { PagesMiddleware } from "../../Store/Middlewares/PagesMiddleware";
import { Skeleton } from "antd";
import HeaderComponent from "../../components/HeaderComponent/HeaderComponent";
const PrivacyPolicy = () => {
  const dummyItem = [
    {
      id: 2,
      text: "Welcome to our service! By using our platform, you agree to the following terms and conditions. Please read them carefully. ",
    },
    {
      id: 3,
      text: "1. **Acceptance of Terms**: By accessing or using our service, you confirm that you accept these terms and agree to comply with them. ",
    },
    {
      id: 4,
      text: "2. **User Responsibilities**: You are responsible for maintaining the confidentiality of your account information and for all activities that occur under your account. ",
    },
    {
      id: 5,
      text: "3. **Prohibited Activities**: You agree not to engage in any unlawful activities or to use the service in a way that could damage, disable, or impair the service. ",
    },
    {
      id: 6,
      text: "4. **Intellectual Property**: All content provided on our platform is owned by us or our licensors. You may not use any content without our prior written permission. ",
    },
  ];
  return (
    <div className={styles.mainCont}>
      <HeaderComponent heading={"Privacy Policy"} headingStyle={styles.headingStyle}/>
      {dummyItem?.map((item, index) => (
        <div className={styles.listItem}>
          <TextComponent
            text={item?.title}
            style={{
              color: "var(--black-color)",
              fontFamily: "Urbanist-bold",
              marginBottom: "10px",
              fontSize: "30px",
            }}
          />
          <TextComponent
            text={item?.text}
            style={{ fontSize: "14px", color: "#525252" }}
          />
        </div>
      ))}
      <TextComponent textClass={styles.tcText}>
        {/* <span
          className={styles.contentStyling}
          dangerouslySetInnerHTML={{ __html: pages?.terms_and_condition }}
        /> */}
      </TextComponent>
    </div>
  );
};

export default PrivacyPolicy;
